import {
    COHORT_LIST_REQUEST, COHORT_LIST_SUCCESS, COHORT_LIST_FAIL,
    COHORT_DETAILS_REQUEST, COHORT_DETAILS_SUCCESS, COHORT_DETAILS_FAIL, COHORT_DETAILS_RESET,
    COHORT_CREATE_REQUEST, COHORT_CREATE_SUCCESS, COHORT_CREATE_FAIL, COHORT_CREATE_RESET,
    COHORT_UPDATE_REQUEST, COHORT_UPDATE_SUCCESS, COHORT_UPDATE_FAIL, COHORT_UPDATE_RESET,
    COHORT_DELETE_REQUEST, COHORT_DELETE_SUCCESS, COHORT_DELETE_FAIL,
    COHORT_DTO_REQUEST, COHORT_DTO_SUCCESS, COHORT_DTO_FAIL, COHORT_DTO_RESET,
    COHORT_LIST_BY_IDS_REQUEST, COHORT_LIST_BY_IDS_SUCCESS, 
    COHORT_LIST_BY_IDS_FAIL, COHORT_LIST_BY_IDS_RESET,
    COHORT_SEND_COHORT_REQUEST, COHORT_SEND_COHORT_SUCCESS, COHORT_SEND_COHORT_FAIL, COHORT_SEND_COHORT_RESET,
} from '../constants/cohortConstants';

export const cohortListReducer = (state = { cohorts: [] }, action) => {
    switch (action.type) {
        case COHORT_LIST_REQUEST:
            return { loading: true, cohorts: [] };
        case COHORT_LIST_SUCCESS:
            return {
                loading: false,
                cohorts: action.payload.items,
                totalPages: action.payload.totalPages,
                currentPage: action.payload.currentPage,
                totalCount: action.payload.totalCount,
            };
        case COHORT_LIST_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const cohortDetailsReducer = (state = { cohort: {} }, action) => {
    switch (action.type) {
        case COHORT_DETAILS_REQUEST:
            return { loading: true, ...state };
        case COHORT_DETAILS_SUCCESS:
            return { loading: false, cohort: action.payload };
        case COHORT_DETAILS_FAIL:
            return { loading: false, error: action.payload };
        case COHORT_DETAILS_RESET:
            return { cohort: {} };
        default:
            return state;
    }
};

export const cohortDtoReducer = (state = { cohortDto: {} }, action) => {
    switch (action.type) {
        case COHORT_DTO_REQUEST:
            return { loading: true, cohortDto: {} };
        case COHORT_DTO_SUCCESS:
            return { loading: false, cohortDto: action.payload };
        case COHORT_DTO_FAIL:
            return { loading: false, error: action.payload };
        case COHORT_DTO_RESET:
            return { cohortDto: {} };
        default:
            return state;
    }
};

export const cohortDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case COHORT_DELETE_REQUEST:
            return { loading: true };
        case COHORT_DELETE_SUCCESS:
            return { loading: false, success: true };
        case COHORT_DELETE_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const cohortCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case COHORT_CREATE_REQUEST:
            return { loading: true };
        case COHORT_CREATE_SUCCESS:
            return { loading: false, success: true, cohort: action.payload };
        case COHORT_CREATE_FAIL:
            return { loading: false, error: action.payload };
        case COHORT_CREATE_RESET:
            return {};
        default:
            return state;
    }
};

export const cohortUpdateReducer = (state = { cohort: {} }, action) => {
    switch (action.type) {
        case COHORT_UPDATE_REQUEST:
            return { loading: true };
        case COHORT_UPDATE_SUCCESS:
            return { loading: false, success: true, cohort: action.payload };
        case COHORT_UPDATE_FAIL:
            return { loading: false, error: action.payload };
        case COHORT_UPDATE_RESET:
            return { cohort: {} };
        default:
            return state;
    }
};

export const cohortListByIdsReducer = (state = { cohorts: [] }, action) => {
    switch (action.type) {
        case COHORT_LIST_BY_IDS_REQUEST:
            return { loading: true, cohorts: [] };
        case COHORT_LIST_BY_IDS_SUCCESS:
            return {
                loading: false,
                cohorts: action.payload,
            };
        case COHORT_LIST_BY_IDS_FAIL:
            return { loading: false, error: action.payload };
        case COHORT_LIST_BY_IDS_RESET:
            return { cohorts: [] };
        default:
            return state;
    }
};

export const cohortSendCohortReducer = (state = {}, action) => {
    switch (action.type) {
        case COHORT_SEND_COHORT_REQUEST:
            return { loading: true };
        case COHORT_SEND_COHORT_SUCCESS:
            return { loading: false, success: true, updatedCount: action.payload.updatedCount };
        case COHORT_SEND_COHORT_FAIL:
            return { loading: false, error: action.payload };
        case COHORT_SEND_COHORT_RESET:
            return {};
        default:
            return state;
    }
}; 